import * as yup from 'yup';
import useFormal from '@kevinwolf/formal-web';

export const schema = yup.object().shape({
  isUser: yup.bool(),
  email: yup
    .string()
    .email('Wrong email format')
    .when('isUser', (isUser, type) => (isUser ? type : type.required('Email is missing'))),
  firstName: yup
    .string()
    .when('isUser', (isUser, type) => (isUser ? type : type.required('Fist name is missing'))),
  lastName: yup
    .string()
    .when('isUser', (isUser, type) => (isUser ? type : type.required('Last name is missing'))),
  password: yup
    .string()
    .when('isUser', (isUser, type) => (isUser ? type : type.min(8, 'Password must be at least 8 characters').required('Password is missing'))),
  websiteName: yup.string().required('Website name is missing'),
  websiteUrl: yup.string().url('Website url must be a valid URL').required('Website url is missing'),
  targetCountry: yup.string().required('Target Audience Country is missing'),
  monthly: yup.string().required('Monthly Visitors is missing'),
  isGdpr: yup.bool().required(),
  isAgree: yup.bool().required(),
});

const initialState = {
  isUser: false,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  password: undefined,
  websiteName: undefined,
  websiteUrl: undefined,
  targetCountry: undefined,
  monthly: undefined,
  feacbookUrl: '',
  instagramUrl: '',
  twitterUrl: '',
  youtubeUrl: '',
  isGdpr: false,
  isAgree: false,
};

export default function useSignUpForm(initialForm = initialState, onSubmit) {
  const formal = useFormal(initialForm, {
    schema,
    onSubmit,
  });
  return formal;
}
